
const today = new Date();
const maxDate=today.setDate(today.getDate() + 1)
export const date = {
  minDate: "1900/01/01",
  maxDate: maxDate,
};

export const ivalidDate = {
  ivalidDate:"Invalid Date",
  validdob:'validdob',
}
export const limitDate = {
 day:13,
 month:32,
}
export const currentYear = new Date().getFullYear()